import React, { useState } from 'react';

import { makeStyles } from '@material-ui/styles';

import Compressor from 'compressorjs';

import { dataToBlob } from './dataToBlob';
import Typography from '@material-ui/core/Typography';
import MessagePopUp from '../Components/MessagePopup';
import { ButtonPrimary } from '../Components/StyledComponent';

export function AccessDevice({
  id,
  camera,
  reparos,
  disabled,
  documents,
  buttonText,
  buttonIcon,
  setDocuments,
  tema,
  fileQuantityAllowed,
}) {
  const [showModalInvalidFileSize, setShowModalInvalidFileSize] =
    useState(false);

  const [showFileDuplicatedModal, setShowFileDuplicatedModal] = useState(false);

  const [showInvalidFormatErrorModal, setShowInvalidFormatErrorModal] =
    useState(false);

  const useStyles = makeStyles({
    button: {
      fontSize: 18,
      width: '100%',
      color: tema?.primaryColor,
      borderRadius: 8,
      display: 'flex!important',
      transition: '0.3s',
      alignItems: 'center',
      background: 'transparent',
      border: `2px solid ${tema?.primaryColor}`,
      justifyContent: 'center',
      opacity: disabled && '0.5',
      textTransform: 'uppercase',
      cursor: !disabled && 'pointer',
      height: documents?.documents === undefined ? 56 : 40,
      '&:hover': {
        backgroundColor: tema?.primaryColor,
        color: '#fff',
      },
    },
  });

  const classes = useStyles();

  const verifyIfFileExists = (file) => {
    const fileExists = documents.some((document) => document === file);

    if (fileExists) {
      setShowFileDuplicatedModal(true);
    }

    return fileExists;
  };

  const verifyValidExtension = async (file) => {
    if (
      file.includes('image/jpeg') ||
      file.includes('image/jpg') ||
      file.includes('image/png') ||
      file.includes('application/pdf') ||
      file.includes('video/mp4') ||
      file.includes('video/webm') ||
      file.includes('video/avi') ||
      file.includes('video/mkv')
    ) {
      return true;
    } else {
      setShowInvalidFormatErrorModal(true);
    }
  };

  const verifyFileSize = (file) => {
    let fileSizeInMb = file.size / 1024 / 1024;

    if (fileSizeInMb <= 30) {
      return true;
    } else {
      setShowModalInvalidFileSize(true);
    }
  };

  const insertImageIntoArray = (event, image) => {
    if (documents?.idSelecaoReparo === undefined) {
      setDocuments([...documents, image]);
    } else {
      let newReparos = [];

      reparos.map((reparo) => {
        if (reparo.idSelecaoReparo === documents.idSelecaoReparo) {
          if (reparo.documents === undefined) {
            reparo.documents = [];
          }

          reparo.documents.push(image);

          newReparos.push({
            ...reparo,
          });
        } else {
          newReparos.push(reparo);
        }
      });

      setDocuments(newReparos);
    }
  };

  const compressImage = (image, event) => {
    if (image?.includes('application/pdf') || image?.includes('video/mp4')) {
      if (verifyFileSize(dataToBlob(image))) {
        insertImageIntoArray(event, image);
      }
    } else {
      try {
        new Compressor(dataToBlob(image), {
          quality: 0.8,
          success: (compressedResult) => {
            if (verifyFileSize(compressedResult)) {
              insertImageIntoArray(event, compressedResult);
            }
          },
        });
      } catch (e) {
        console.error(e);
      }
    }
  };

  const handleFile = (event) => {
    const reader = new FileReader();

    reader.onload = async () => {
      if (reader.readyState === 2) {
        if (
          (await verifyValidExtension(reader.result)) &&
          !verifyIfFileExists(reader.result)
        ) {
          compressImage(reader.result, event);
        }
      }
    };

    if (event.target.files[0]) {
      reader.readAsDataURL(event.target.files[0]);
    }

    event.target.value = null;
  };

  return (
    <>
      <label htmlFor={id} className={classes.button}>
        <input
          id={id}
          type='file'
          disabled={disabled}
          onChange={handleFile}
          style={{ display: 'none' }}
          accept='.jpg, .jpeg, .png, .pdf, .mp4'
          capture={camera ? 'environment' : false}
        />

        {buttonIcon}

        <p style={{ marginLeft: buttonIcon ? 16 : 0 }}>{buttonText}</p>
      </label>

      <Typography
        variant='caption'
        color='textPrimary'
        style={{ padding: '4px 0 6px 0', display: 'block' }}
      >
        Você pode anexar até {fileQuantityAllowed} arquivos, com o tamanho
        máximo de 30MB cada. O envio de anexos não é obrigatório.
      </Typography>

      {showModalInvalidFileSize && (
        <MessagePopUp
          isError
          title={'Tamanho inválido'}
          message={
            <span>
              Você pode <b>anexar</b> até {fileQuantityAllowed} arquivos, com o{' '}
              <b>tamanho máximo de 30MB</b> cada.
            </span>
          }
        >
          <ButtonPrimary
            tema={tema}
            fullWidth
            onClick={() => setShowModalInvalidFileSize(false)}
          >
            FECHAR
          </ButtonPrimary>
        </MessagePopUp>
      )}
      {showFileDuplicatedModal && (
        <MessagePopUp
          isError
          title={'Documento duplicado'}
          message={
            'Este documento já foi adicionado. Não é possível adicionar documentos iguais.'
          }
        >
          <ButtonPrimary
            tema={tema}
            fullWidth
            onClick={() => setShowFileDuplicatedModal(false)}
          >
            FECHAR
          </ButtonPrimary>
        </MessagePopUp>
      )}

      {showInvalidFormatErrorModal && (
        <MessagePopUp
          isError
          title={'Formato de arquivo inválido'}
          message={
            <span>
              O documento precisa estar no formato jpg, png, pdf, ou mp4.
              <br />
              <br />
              Por favor, tente novamente.
            </span>
          }
        >
          <ButtonPrimary
            tema={tema}
            fullWidth
            onClick={() => setShowInvalidFormatErrorModal(false)}
          >
            FECHAR
          </ButtonPrimary>
        </MessagePopUp>
      )}
    </>
  );
}
